<template>
  <section class="location-section" ref="locationSection" id="Contact">
    <div class="location-container">
      <h2 class="section-title">LOCATION And HOURS</h2>

      <div class="location-content">
        <!-- Real Google Maps -->
        <div class="map-container" ref="mapContainer">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d83998.94722687195!2d2.277019!3d48.8589507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e1f06e2b005%3A0x40b82c3688c9460!2sParis%2C%20France!5e0!3m2!1sen!2sdz!4v1234567890"
            width="100%"
            height="100%"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>

        <div class="info-container" ref="infoContainer">
          <!-- Visit Us -->
          <div class="info-item">
            <h3 class="info-title">Visit Us</h3>
            <div class="info-icon-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="#D4A574"/>
              </svg>
              <span class="info-label">Where to Find Us</span>
            </div>
            <p class="info-text">123 Coffee Street<br>Downtown District<br>Paris 12345</p>
          </div>

          <!-- When We're Open -->
          <div class="info-item">
            <h3 class="info-title">When We're Open</h3>
            <div class="info-icon-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="#D4A574"/>
              </svg>
              <span class="info-text-inline">Monday - Sunday<br>7:00 AM - 9:00 PM</span>
            </div>
          </div>

          <!-- Get In Touch -->
          <div class="info-item">
            <h3 class="info-title">Get In Touch</h3>
            <div class="info-icon-row">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="#D4A574"/>
              </svg>
              <span class="info-text-inline">+33 (×××) ×××-×××<br>hello.launchpad.lagency@gmail.com</span>
            </div>
          </div>

          <!-- Follow Our Journey -->
          <div class="info-item">
            <h3 class="info-title">Follow Our Journey</h3>
            <div class="info-icon-row">

              <div class="social-links">
                <a href="https://www.tiktok.com" class="social-icon" target="blank">
               <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 24 24">
	<path fill="#D4A574" d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48" />
</svg>
                </a>
                <a href="https://www.instagram.com/tahx__?igsh=MWo4czR6MnR1Mjg3aA==" class="social-icon" target="blank">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 32 32">
	<path fill="#D4A574" d="M11.469 5C7.918 5 5 7.914 5 11.469v9.062C5 24.082 7.914 27 11.469 27h9.062C24.082 27 27 24.086 27 20.531V11.47C27 7.918 24.086 5 20.531 5zm0 2h9.062A4.463 4.463 0 0 1 25 11.469v9.062A4.463 4.463 0 0 1 20.531 25H11.47A4.463 4.463 0 0 1 7 20.531V11.47A4.463 4.463 0 0 1 11.469 7m10.437 2.188a.9.9 0 0 0-.906.906c0 .504.402.906.906.906a.9.9 0 0 0 .907-.906a.9.9 0 0 0-.907-.906M16 10c-3.3 0-6 2.7-6 6s2.7 6 6 6s6-2.7 6-6s-2.7-6-6-6m0 2c2.223 0 4 1.777 4 4s-1.777 4-4 4s-4-1.777-4-4s1.777-4 4-4" />
</svg>
                </a>
                <a href="https://www.facebook.com" class="social-icon" target="blank">
                 <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 24 24">
	<path fill="#D4A574" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4z" />
</svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LocationSection',
  mounted() {
    this.observeSections();
  },
  methods: {
    observeSections() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.15
      });

      observer.observe(this.$refs.locationSection);
      observer.observe(this.$refs.mapContainer);
      observer.observe(this.$refs.infoContainer);
    }
  }
}
</script>

<style scoped>
.location-section {
  width: 100%;
  padding: 6rem 2rem;
  background: #FFF8DC;
}

.location-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  color: #6F4E37;
  text-align: center;
  margin-bottom: 4rem;
}

.location-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: stretch; /* هذي مهمة - تخلي الخريطة تمتد */
}

.map-container {
  width: 100%;
  min-height: 500px; /* minimum height */
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(111, 78, 55, 0.15);
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  align-self: stretch; /* تخلي الخريطة تاخذ كل ارتفاع المحتوى */
}

.map-container.visible {
  opacity: 1;
  transform: translateX(0);
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s;
}

.info-container.visible {
  opacity: 1;
  transform: translateX(0);
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.4rem;
  font-weight: 600;
  color: #6F4E37;
  margin-bottom: 0.25rem;
}

.info-icon-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.info-icon-row svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.info-label {
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: #8B7355;
  font-weight: 500;
}

.info-text {
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  line-height: 1.8;
  color: #8B7355;
  padding-left: 28px;
}

.info-text-inline {
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  line-height: 1.8;
  color: #8B7355;
}

.social-links {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.social-icon {
  width: 36px;
  height: 36px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF8DC;
  transition: all 0.5s ease-out;
}


.social-icon svg path {
  fill: rgba(111, 78, 55, 0.763); /* اللون الأساسي */
  transition: fill 0.5s ease-out;
}

/* تغيير اللون عند الـ hover */
.social-icon:hover svg path {
  fill: #6F4E37; /* aqua/cyan */
}
/* Responsive */
@media (max-width: 1024px) {
  .location-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .map-container {
    min-height: 400px;
  }
}

@media (max-width: 768px) {
  .location-section {
    padding: 4rem 1.5rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .map-container {
    min-height: 350px;
  }

  .info-item {
    gap: 0.5rem;
  }

  .info-title {
    font-size: 1.2rem;
  }
}
</style>